module.exports = {"id":true,"registration":true,"drivers":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/user/vehicles.json
// module id = MCp5
// module chunks = 1